import Main from "@/components/main";

/**
 * iview-admin中meta除了原生参数外可配置的参数:
 * meta: {
 *  title: 页面title
 *  requireAuth:页面不需要登录
 *  breadcrumb：面包屑导航
 * }
 */
export default [
  {
    path: "/login",
    name: "/login",
    meta: {
      title: "登录-国武",
      requireAuth: true
    },
    component: () => import("@/views/login/login")
  },
  {
    path: "/forgetPassword",
    name: "forgetPassword",
    meta: {
      title: "忘记密码-国武",
      requireAuth: true
    },
    component: () => import("@/views/login/forgetPassword")
  },
  {
    path: "/",
    name: "_home",
    redirect: "/home",
    component: Main,
    children: [
      {
        path: "/home",
        name: "home",
        meta: {
          title: "首页-国武",
        },
        component: () => import("@/views/home/index")
      }, {
        path: "/classList",
        name: "classList",
        meta: {
          breadcrumb: "班级管理",
          title: "班级管理",
        },
        component: () => import("@/views/classList/index")
      },
      {
        path: "/teacherList",
        name: "teacherList",
        meta: {
          breadcrumb: "老师管理",
          title: "老师管理",
        },
        component: () => import("@/views/teacherList/index")
      },
      {
        path: "/studentList",
        name: "studentList",
        meta: {
          breadcrumb: "学员列表",
          title: "学员列表"
        },
        component: () => import("@/views/studentList/index")
      },
      {
        path: "/organ",
        name: "organ",
        meta: {
          breadcrumb: "门店管理",
          title: "门店管理"
        },
        component: () => import("@/views/organ/index")
      },
      {
        path: "/user",
        name: "user",
        meta: {
          breadcrumb: "账号管理",
          title: "账号管理"
        },
        component: () => import("@/views/user/index")
      }
      , {
        path: "/rowcourse",
        name: "courseManagement",
        meta: {
          breadcrumb: "排课管理",
          title: "排课管理"
        },
        component: () => import("@/views/courseManagement/index")
      }
      , {
        path: "/weekcourse",
        name: "weekcourse",
        meta: {
          breadcrumb: "星期排课",
          title: "星期排课"
        },
        component: () => import("@/views/weekcourse/index")
      }
      , {
        path: "/studentelde",
        name: "studentelde",
        meta: {
          breadcrumb: "学员风采",
          title: "学员风采"
        },
        component: () => import("@/views/studentelde/index")
      }
      , {
        path: "/eliminate",
        name: "eliminate",
        meta: {
          breadcrumb: "消课记录",
          title: "消课记录"
        },
        component: () => import("@/views/eliminate/index")
      }
      , {
        path: "/leave",
        name: "leave",
        meta: {
          breadcrumb: "请假记录",
          title: "请假记录"
        },
        component: () => import("@/views/leave/index")
      }
      , {
        path: "/exportExcel",
        name: "exportExcel",
        meta: {
          breadcrumb: "Excel导出",
          title: "Excel导出"
        },
        component: () => import("@/views/exportExcel/index")
      }
    ]
  },
  // 未知页面
  {
    path: "*",
    name: "error",
    component: Main,
    // redirect: '/home',
  }
];



// WEBPACK FOOTER //
// ./src/router/routers.js